import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

export interface FooterBarProps {
    isDirty: boolean;
    isSaving: boolean;
    hasValidationErrors: boolean;
    onReset: () => void;
    onSave: () => void;
    onCancel: () => void;
}

export const FooterBar = (props: FooterBarProps) => {
    return (
        <div className='border-border-default inline-flex items-center justify-between self-stretch border-t p-4'>
            <DefaultSecondaryButton
                text={
                    <FormattedMessage
                        id='footer-bar.reset-message'
                        description='Button label for resetting notification content editor changes'
                        defaultMessage='Reset message'
                    />
                }
                disabled={!props.isDirty || props.isSaving}
                onClick={props.onReset}
            />
            <div className='flex items-center justify-start gap-3'>
                <DefaultSecondaryButton
                    text={CommonMessage.BUTTONS.CANCEL}
                    disabled={props.isSaving}
                    onClick={props.onCancel}
                />
                <DefaultPrimaryButton
                    text={
                        <FormattedMessage
                            id='footer-bar.save-changes'
                            description='Button label for saving notification content editor changes'
                            defaultMessage='Save changes'
                        />
                    }
                    disabled={!props.isDirty || props.hasValidationErrors || props.isSaving}
                    isLoading={props.isSaving}
                    onClick={props.onSave}
                />
            </div>
        </div>
    );
};
